export enum FirstLoginStepsType {
  welcomeScreen = "welcome-screen",
  digestMedia = "digest-media",
  takeLook = "take-look",
}
